import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

const GOOGLE_CLIENT_ID = "445054121959-aibahab0cenq62ru5aslu6m5i76v6ecs.apps.googleusercontent.com";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem(`token`);
      localStorage.removeItem(`temtoken`);
      localStorage.removeItem(`user`);
      localStorage.removeItem(`source`);
      localStorage.removeItem(`profilePicture`);
      localStorage.removeItem(`backgroundColor`);
      localStorage.removeItem(`initial`);
      localStorage.removeItem('deviceToken');
      window.location.href = '/?login=true';
    }
    return Promise.reject(error);
  }
);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
  <App />
  </GoogleOAuthProvider>
</BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
